<template>
    <div>
        <div v-for="(item, index) in Collection" :key="item.guid" :class="dataClass">
            <dtc-image-uploader :item="item"
                                :upload-url='uploadUrl'
                                :delete-url="deleteUrl"
                                :img-options="imgOptions"
                                v-on:add-image="addItem($event, item)"
                                v-on:delete-image="deleteItem(item)"></dtc-image-uploader>
        </div>
    </div>
</template>

<script>
    export default{
        data() {
            return {
                Collection: [],
            }
        },
        props : {
            dataClass : String,
            dataImages : {
                type: Array,
                default: function() { return [] },
            },
            imgOptions: {
                type: Object,
            },
            uploadUrl: {
               type: String,
                default: null 
            },
            deleteUrl : {
                type: String,
                default: null
            }
        },
        methods: {
            addItem: function(e, item){
                var index = _.indexOf(this.Collection, item);
                console.log('addItem', e, item);
                this.Collection.splice(index, 1, e);
                this.Collection.push(this.newItem());
                this.$emit('collectionUpdated', this.cleanCollection)
            },
            deleteItem: function(item) {
                var index = _.indexOf(this.Collection, item);
                console.log(index);
                this.Collection.splice(index, 1);
                this.$emit('collectionUpdated', this.cleanCollection)
            },
            guidGenerator: function () {
                var now = Date.now();
                console.log(now);
                return now;
                var S4 = function() {
                    return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
                };
                return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
            },
            newItem: function() {
                return {
                    guid: this.guidGenerator()
                };
            }
        },
        computed: {
            cleanCollection: function(){
                console.log(this.Collection);
                var cleanCollect = _.filter(this.Collection, function(item) {
                    return !_.isUndefined(item.id);
                });
                console.log(cleanCollect);
                return cleanCollect;
            }
        },
        watch: {
            /*
            dataImages: function (images) {
               console.log(images);
                var vm = this;
                var i = 0;
                _.forEach(images, function(image){
                    console.log(image);
                    vm.Collection.splice(i, 1, image);
                    i++;
                });
            }
            */
        },
        created(){
            var vm = this;
            var dataImages = _.cloneDeep(this.dataImages);
            var collection = _.map(dataImages, function(item){
                item.guid = vm.guidGenerator();
                return item;
            });
            collection.push(this.newItem());
            this.Collection = collection;
        }
    }
</script>